<div class="flex flex-col">
  <div class="notification-message-container w-p-100 m-0 m-b-20 ">
    <div>
      <span>Note:</span> Once you start this data survey, Orbitax will send a notification to each participant. You can
      include a custom message in the box below.
    </div>
  </div>
  <div class="data-submit-container m-b-20 flex flex-col">
    <div class="title">By continuing you will be sending an email notification to:</div>
    <ul>
      <li><span class="new">{{data.input.person}}</span> people</li>
    </ul>
  </div>

  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Message</mat-label>
      <textarea matInput type="text" [(ngModel)]="data.input.message"
                rows="5">
              </textarea>
    </mat-form-field>
  </div>

</div>
